import { Card, CardBody, Col } from "reactstrap";
import { ColorsTitle } from "../../../Constants/Constants";
import { ColorsData, ColorsSubTitle } from "../../../Data/UiKits/Placeholders";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Colors = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={ColorsTitle} span={ColorsSubTitle} />
        <CardBody className="placeholder-glow">
          <Col xl="12"><span className="placeholder w-100" /></Col>
          {ColorsData.map((item, index) => (
            <Col xl="12"><span className={`placeholder w-100 bg-${item}`} key={index} /></Col>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Colors;
